<div class="flex-row align-center-center">
    <mat-spinner *ngIf="spinner" class="mrs-3" color="primary" diameter="20">
    </mat-spinner>
    <mat-form-field class="flex-100" [formGroup]="form" appearance="outline">
        <!-- <mat-label *ngIf="this.label">
            <mat-icon *ngIf="this.icon">{{ icon }}</mat-icon>
            {{ label }}
        </mat-label> -->
        <mat-select multiple [formControlName]="name" id="{{name}}" placeholder="{{placeholder}}"
            [disabled]="disabled ? disabled : false" (selectionChange)="change($event)">
            <!-- 🔎 Barra de búsqueda -->
            <ngx-mat-select-search [placeholderLabel]="placeholderSearching" [searching]="searchingSpinner"
                [noEntriesFoundLabel]="placeholderNoValue" [formControlName]="nameSearching">
            </ngx-mat-select-search>

            <!-- Opcional: texto cuando no haya ninguna opción (si lo usás en single) -->
            <!-- <mat-option *ngIf="this.noOptionText">{{ noOptionText }}</mat-option> -->

            <!-- Lista filtrada -->
            <mat-option
                *ngFor="let element of filteredValues | async"
                [disabled]="element?.disabled"
                [value]="+element.id">
                {{ element.name }}
                </mat-option>
        </mat-select>

        <mat-error *ngIf="this.form.get(this.name)?.errors &&
             (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched)">
            {{ getError() }}
        </mat-error>
    </mat-form-field>
</div>
